import { Navigate } from 'react-router-dom';

import { useUserSelector } from '@occc-app/App/AppContext';
import { User_Role } from '@occc/graphql';
import { routeCreator as locationRouteCreator } from '@occc-app/routes/Location/utils';
import { routeCreator as memberRouteCreator } from '@occc-app/routes/Member/utils';
import {
  routeCreator as retailerNetworkRouteCreator,
  useRetailerConnectUser,
} from '@occc/feat-retailer-connect';

import config from '@occc/config';

import UnauthorizedPage from '../Unauthorized';

const RedirectByUserRole = () => {
  const user = useUserSelector();

  const {
    isRetailerNetworkUserRole,
    isRetailerNetworkSiteUserRole,
    retailerNetworkUserId,
    retailerNetworkId,
  } = useRetailerConnectUser();

  const shouldNavigateToDashboard =
    user?.userRole === User_Role.Admin ||
    user?.userRole === User_Role.AdminReadOnly ||
    user?.userRole === User_Role.ScanDataAdmin ||
    user?.userRole === User_Role.ScanDataUser;

  if (config.isLiteVersion) {
    return <Navigate to={locationRouteCreator.list()} replace />;
  }

  if (shouldNavigateToDashboard) {
    return <Navigate to='/dashboard' replace />;
  }

  if (user?.userRole === User_Role.Support) {
    return <Navigate to={memberRouteCreator.base()} replace />;
  }

  if (user?.userRole === User_Role.Sitetech) {
    return <Navigate to={locationRouteCreator.list()} replace />;
  }

  if (isRetailerNetworkUserRole) {
    return <Navigate to={retailerNetworkRouteCreator.base()} replace />;
  }

  if (isRetailerNetworkSiteUserRole && retailerNetworkId && retailerNetworkUserId) {
    return (
      <Navigate
        to={retailerNetworkRouteCreator.userDetails(retailerNetworkId, retailerNetworkUserId)}
        replace
      />
    );
  }

  return <UnauthorizedPage />;
};

export default RedirectByUserRole;
